module.exports = __webpack_public_path__ + "img/facebook2.e72530db.png";